import React from 'react'
import Fragment from '../common/fragment'


function FragmentAJ(props) {
  return (
    <Fragment pos="j" {...props}>
      <p>
A las ovejas que pastan en los valles, ¿les inquietan las máquinas?
      </p>
    </Fragment>
  )
}


export default FragmentAJ
